import { render, staticRenderFns } from "./CostInfoCard.vue?vue&type=template&id=39068d48"
import script from "./CostInfoCard.vue?vue&type=script&lang=js"
export * from "./CostInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports